export const contentSections = [
    {
        title: 'WHAT_DOES_IT_MEAN_TO_WORK_AS_FREELANCER',
        paragraphs: [
            'FREELANCER_DEFINITION_TEXT_1',
            'FREELANCER_DEFINITION_TEXT_2',
        ],
    },
    {
        title: 'FREELANCE_JOBS_WHERE_TO_FIND_THEM',
        paragraphs: [
            'FREELANCE_JOBS_TEXT_1',
            'FREELANCE_JOBS_TEXT_2',
        ],
    },
    {
        title: 'ENSURE_ABILITY_TO_MARKET_YOURSELF',
        paragraphs: [
            'MARKETING_YOURSELF_TEXT_1',
            'MARKETING_YOURSELF_TEXT_2',
        ],
    },
    {
        title: 'WHAT_PROFESSIONS_CAN_I_FREELANCE_IN',
        intro: 'FREELANCE_PROFESSIONS_INTRO',
        list: [
            'WEB_DEVELOPMENT',
            'TRANSLATION_AND_LANGUAGE_SERVICES',
            'COPYWRITING_AND_CONTENT_WRITING',
            'MARKETING_AND_SOCIAL_MEDIA',
            'PHOTOGRAPHY_AND_IMAGE_EDITING',
            'CONSULTING_SERVICES',
            'GRAPHIC_DESIGN',
        ],
        conclusion: [
            'FREELANCE_PROFESSIONS_CONCLUSION_1',
            'FREELANCE_PROFESSIONS_CONCLUSION_2',
        ],
    },
    {
        title: 'DEMAND_FOR_FREELANCERS_IN_MOST_INDUSTRIES',
        paragraphs: [
            'INDUSTRY_DEMAND_TEXT_1',
            'INDUSTRY_DEMAND_TEXT_2',
            'INDUSTRY_DEMAND_TEXT_3',
            'INDUSTRY_DEMAND_TEXT_4',
        ],
    },
    {
        title: 'INVOICING_WITHOUT_FTAX_VS_STARTING_COMPANY',
        paragraphs: [
            'INVOICING_WITHOUT_FTAX_TEXT_1',
            'INVOICING_WITHOUT_FTAX_TEXT_2',
        ],
    },
];